module.exports = __webpack_public_path__ + "static/media/straighten_05.355ffd80.png";